<template>
    <div>
      <strong>{{"Configure by:"}}</strong><br/>  
          <b-row>
            <b-col>
              <b-form inline @submit.prevent="" class="mb-2">
                <b-input-group class="filter-group mr-2">
                  <b-input-group-prepend is-text class="semester-input-group">
                    Term
                  </b-input-group-prepend>

                  <b-form-select v-model="term"
                        :options="terms"
                        value-field="termId"
                        text-field="description"
                        id="terms" 
                        @input="loadConfig"
                        >

                    <template slot="first">
                      <!-- this slot appears above the options from 'options' prop -->
                      <option :value="null">All</option>
                    </template>
                  </b-form-select>
                </b-input-group>

                <b-input-group class="filter-group mr-2">
                  <b-input-group-prepend is-text class="semester-input-group">
                    Opportunity Type
                  </b-input-group-prepend>
                  
                  <!-- the v-model prop is the actual value of the dropdown, NOT THE ELEMENT ITSELF!!! not like jQuery!!!! (Andrew: "taking away a few steps :)") -->
                  <b-form-select 
                                id="opportunityType" 
                                v-model="opportunityTypeId"   
                                :options="opportunityTypes"
                                value-field="opportunityTypeId"
                                text-field="name"
                                @input="loadConfig"
                                >

                              <template slot="first">
                                <!-- this slot appears above the options from 'options' prop -->
                                <option :value="null">All</option>
                              </template>
                  </b-form-select>
                </b-input-group>
              </b-form>
            </b-col>
          </b-row>

    <b-table striped
          hover
          :items="opportunityTermAndClassConfigData"
          :fields="fields"
          :per-page="500">

        <template slot="class" slot-scope="data">
          <!-- THESE ARE ACTUAL VALUES RETURNED BY THE API!! -->
          {{ data.item.subjectCode + " " + data.item.catalogNumber }}
        </template>

        <template slot="classNumber" slot-scope="data">
          <input type="text" class="form-control" v-model="data.item.classNumber"/>
        </template>

        <template slot="startDate" slot-scope="data">
            <datepicker                  
            inputClass="form-control"
            format="MM/dd/yyyy"
            :typeable="true"
            v-model="data.item.startDate"
          ></datepicker>
        </template>

        <template slot="endDate" slot-scope="data">
          <datepicker
          inputClass="form-control"
          format="MM/dd/yyyy"
          :typeable="true"
          v-model="data.item.endDate"
          ></datepicker>
        </template>

        <template slot="instructor" slot-scope="data">
          <input type="text" class="form-control" v-model="data.item.instructor"/> 
        </template>

        <template slot="coordinator" slot-scope="data">
          <input type="text" class="form-control" v-model="data.item.coordinator"/> 
        </template>

        <template slot="action" slot-scope="data">
          <button class="btn btn-primary" @click="saveRow(data.item)">Save</button>
          &nbsp;
          <button class="btn btn-primary" @click="copyRow(data.item, data.index)">Copy</button>
        </template>
    </b-table>
  </div>
</template>

<script>
import terms from "../../../api/terms";
import opportunities from "../../../api/opportunity";
import termAndClassConfig from "../../../api/opportunityTermAndClassConfig";
//import * as _ from "lodash";
//import Vue from "vue";
import toastr from "toastr";
import ToastrSettings from "../../../settings/toastr-settings";
//import { forEach } from "lodash";

export default {
  data() {
    return {
      // COLUMN HEADINGS, NOT ACTUAL VALUES!!!
      fields: [
        { key: "class" },
        { key: "startDate" },
        { key: "endDate" },
        { key: "instructor" },
        { key: "coordinator" },
        { key: "classNumber" },
        { key: "action" }
      ],
      // totalRows: 0,
      // counter: 0,
      // filter: null,
      term: null,
      terms: [],
      opportunityTypes: [],
      opportunityTypeId: null,

      opportunityTermAndClassConfigData: [],
      startDate: "",
      endDate: ""
    };
  },

  props: {
    configData: {
      type: Array,
      // required: true,
      default() {
        return [];
      }
    }
  },

  computed: {},

  methods: {
    saveRow(item) {
      const response = termAndClassConfig
        .saveOpportunityTermAndClassConfigData(item)
        .then(function() {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success(
            "The opportunity configuration has been saved.",
            "Success"
          );
        })
        .catch(function(error) {
          console.log("ERROR! ");
          console.log(error);
          console.log(response);
          toastr.error("Row could not be saved.", "Error");
        });
    },

    copyRow(item, index) {
      var newItem = _.clone(item);

      newItem.id = null;

      // debug
      // newItem.class = "XYZ 123";
      // newItem.instructor = "TEST TEST 111";
      // newItem.coordinator = "ABC ABC 123";
      // newItem.classNumber = "1234";

      this.opportunityTermAndClassConfigData.splice(index + 1, 0, newItem);
    },

    async loadConfig() {
      if (this.opportunityTypeId && this.term) {
        console.log("Opportunity type is: " + this.opportunityTypeId);
        console.log("Term is: " + this.term);

        const response = await termAndClassConfig.getOpportunityTermAndClassConfigData(
          this.term,
          this.opportunityTypeId
        );

        this.opportunityTermAndClassConfigData = response.data;
      }
    }
  },

  created() {
    terms.getCurrentAndFutureTerms().then(response => {
      this.terms = response.data;
    });
    opportunities.getOpportunityTypes().then(response => {
      this.opportunityTypes = response.data;
    });
  }
};
</script>
